import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import api from '../api';

const Navbar = () => {
  const [settings, setSettings] = useState({
    logo_text: '',
    logo_image: '',
    site_name: 'ecom',
    primary_color: '#1a1a1a',
    accent_color: '#c9a96e',
    logo_color_1: '#1a1a1a',
    logo_color_2: '#c9a96e',
  });
  const [loaded, setLoaded] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => { setMenuOpen(false); }, [location]);

  useEffect(() => {
    api.get('/api/settings').then(({ data }) => {
      setSettings(s => ({ ...s, ...data.data }));
      setLoaded(true);
    }).catch(() => setLoaded(true));
  }, []);

  const logoText = settings.logo_text || settings.site_name || 'ecom';

  return (
    <nav className="navbar">
      <div className="container">
        <Link to="/" className="navbar-brand">
          {/* Ne rien afficher tant que les settings ne sont pas chargés */}
          {loaded && (
            settings.logo_image ? (
              <img src={settings.logo_image} alt={logoText} style={{ height: 40, objectFit: 'contain' }} />
            ) : (
              <>
                <span style={{ color: settings.logo_color_1 }}>{logoText.slice(0, 1)}</span>
                <span style={{ color: settings.logo_color_2 }}>{logoText.slice(1)}</span>
              </>
            )
          )}
        </Link>

        {/* Desktop links */}
        <div className="navbar-links">
          <Link to="/">Home</Link>
          <Link to="/products">Shop</Link>
          <Link to="/contact">Contact</Link>
        </div>

        {/* Hamburger button (mobile only) */}
        <button
          className="navbar-burger"
          onClick={() => setMenuOpen(o => !o)}
          aria-label="Menu"
        >
          <span /><span /><span />
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="navbar-mobile">
          <Link to="/">Home</Link>
          <Link to="/products">Shop</Link>
          <Link to="/contact">Contact</Link>
        </div>
      )}
    </nav>
  );
};

export default Navbar;